"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleHeader = void 0;
var React = require("react");
var styles_1 = require("@/pages/articleDetail/components/ArticleHeader/styles");
var core_1 = require("@material-ui/core");
var AuthorAndShare_1 = require("@/pages/articleDetail/components/AuthorAndShare/AuthorAndShare");
exports.ArticleHeader = function (_a) {
    var newsArticleDetail = _a.newsArticleDetail;
    var data = newsArticleDetail.data, translate = newsArticleDetail.translate;
    var title = data.title, postedDateText = data.postedDateText, lastUpdatedText = data.lastUpdatedText;
    var posted = translate.posted, lastUpdated = translate.lastUpdated;
    return (React.createElement(styles_1.Container, null,
        React.createElement(styles_1.Title, null, title),
        React.createElement(styles_1.DateContainer, null,
            React.createElement(styles_1.Date, null,
                React.createElement("i", null, posted + ": " + postedDateText)),
            React.createElement(core_1.Hidden, { xsDown: true },
                React.createElement(styles_1.Date, null, " | ")),
            React.createElement(styles_1.Date, null,
                React.createElement("i", null, lastUpdated + ": " + lastUpdatedText))),
        React.createElement(styles_1.AuthorAndShareContainer, null,
            React.createElement(AuthorAndShare_1.AuthorAndShare, { newsArticleDetail: newsArticleDetail }))));
};
